import { convertChannelCasing } from 'lib-shared-api-utils';
import { Conversation } from 'lib-shared-legacy-types';
import { Channel, channels } from 'lib-shared-types-channels';

import { isNewestFacebookConversation } from './isNewestFacebookConversation';

export function canClaimConversation(
  conversation: Conversation,
  isAssignedToMe: boolean,
  latestFacebookCsid: number,
): boolean {
  if (isAssignedToMe) {
    return false;
  }

  if (!conversation.is_closed) {
    return true;
  }

  const initialChannel = conversation.initial_channel;

  if (!initialChannel) {
    return false;
  }

  if (initialChannel === 'facebookmessenger') {
    return isNewestFacebookConversation(conversation, latestFacebookCsid);
  }

  return channels.includes(
    convertChannelCasing(initialChannel, 'snake') as Channel,
  );
}
